import styled from 'styled-components'
import React, { useContext } from 'react'
import Toggle from 'react-toggle'
import { requestTranslation } from '@futures-platform/i18n'
import {radarAPIs} from '../../helpers/fetcher'


// import { ACTIONS } from '../store/Actions'
// import { DataContext } from '../store/GlobalState'

const ToggleSwitcher = ({ checkPublicLinkExsited , openPublicLinkModal , isDeactivated, type='activate', labelText='Activate', isNotShownLabel, setStatus }) => {
  const params = new URLSearchParams(window.location.search)
  const radar = Number(params.get('node'))

  const handleShowTagsToggle = (e) => {
    e.stopPropagation()
    // e.preventDefault()
    
    switch (type) {
      case 'activate':
        setStatus(() => !isDeactivated)
        const payload = {"enable_embedding": !isDeactivated ? 0: 1, "enable_public_share_url": !isDeactivated ? 0 : 1}
        radarAPIs.switchSharedLink(radar, payload)
        if(!!isDeactivated) {
          !!openPublicLinkModal && openPublicLinkModal()
          const payload2 = {
            login_expire : 0
          }
          !!checkPublicLinkExsited && radarAPIs.setExpiredSharedLink(radar, payload2)
        }
        break
      case 'expirationDate':
        setStatus(() => !isDeactivated)
        const payload2 = {
          login_expire : !isDeactivated ? 0: Math.floor(Date.now() / 1000)
        }
        radarAPIs.setExpiredSharedLink(radar, payload2)
        break
      default:
        break
    }
  }
  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: 'fit-content',
          marginRight: '11px'
        }}>
        {
          !isNotShownLabel && (
            <TextSwitch> {labelText}</TextSwitch>
          )
        }
        {/* <Switch className="switch"> */}
        {/* <Switch>
          <SwitchInput
            type="checkbox"
            checked={!isDeactivated}
            onClick={handleShowTagsToggle}
          />
          <SliderRound></SliderRound>
        </Switch> */}
        <label style={{
          margin: 0,
          display: 'flex',
          alignItems: 'center'
        }}>
          <Toggle
            defaultChecked={!isDeactivated}
            checked={!isDeactivated}
            icons={false}
            onChange={handleShowTagsToggle}
          />
        </label>
      </div>
    </>
  )
}

export default ToggleSwitcher

const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 56px !important;
  height: 26px !important;
  margin-bottom: 12px;
  margin-right: 3px;
`
const SliderRound = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
  &:before {
    position: absolute;
    content: '';
    height: 24px;
    width: 24px;
    left: 1px;
    bottom: 1px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
`

const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + ${SliderRound} {
    background-color: #21aff3;
  }
  &:focus + ${SliderRound} {
    box-shadow: 0 0 1px #2196f3;
  }
  &:checked + ${SliderRound}:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
    border: 1px solid green;
    left: 7px;

    position: absolute;
    content: '';
    height: 24px;
    width: 24px;
    bottom: 1px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }
`

const TextSwitch = styled.p`
  margin: 0;
  margin-right: 10%;
  font-weight: 500;
  // margin-top: 1.5px;
`
